import { __awaiter } from "tslib";
/* Copyright 2021, Milkdown by Mirone. */
import { createSlice } from '../context';
import { createTimer } from '../timing';
import { getAtom } from '../utility';
import { editorCtx } from './init';
import { marksCtx, nodesCtx, schemaCtx, SchemaReady } from './schema';
export const nodeViewCtx = createSlice({}, 'nodeView');
export const nodeViewTimerCtx = createSlice([], 'nodeViewTimer');
export const NodeViewReady = createTimer('NodeViewReady');
export const nodeView = (pre) => {
    pre.inject(nodeViewCtx).inject(nodeViewTimerCtx, [SchemaReady]).record(NodeViewReady);
    return (ctx) => __awaiter(void 0, void 0, void 0, function* () {
        yield ctx.waitTimers(nodeViewTimerCtx);
        const nodes = ctx.get(nodesCtx);
        const marks = ctx.get(marksCtx);
        const schema = ctx.get(schemaCtx);
        const editor = ctx.get(editorCtx);
        const getViewMap = (atoms, isNode) => atoms
            .map(({ id, view }) => [getAtom(id, schema, isNode), { view: view, id }])
            .map(([atom, { id, view }]) => atom && view
            ? [id, ((...args) => view(editor, atom, ...args))]
            : undefined)
            .filter((x) => !!x);
        const nodeViewMap = getViewMap(nodes, true);
        const markViewMap = getViewMap(marks, false);
        const nodeView = Object.fromEntries([...nodeViewMap, ...markViewMap]);
        ctx.set(nodeViewCtx, nodeView);
        ctx.done(NodeViewReady);
    });
};
//# sourceMappingURL=node-view.js.map